import React from "react";
import "./404NotFound.css";

const LinkNotFound = () => {
  return (
    <div className="notfound-container">
      <img
        src="/img/majesteye-icon-skeye-form-horizontal-white-background.svg"
        alt="SkeyeForm Logo"
        className="responsive-logo"
      />
      <div className="notfound-image">404</div>
      <h1 className="notfound-title">Form Not Found</h1>
      <p className="notfound-message">
        Sorry, the Form you are looking for does not exist or is not available
        right now.
      </p>
    </div>
  );
};

export default LinkNotFound;
